export default {
  noHeader: true,
  body: {
    cmpt: {
      type: 'CTdlPackageData'
    }
  }
}
